import { theme } from '@frontend/theme';
import { CheckboxField, useControlledField } from '@frontend/design-system';

export const AvatarCheckbox = ({
  isSelected = false,
  disabled = false,
  onChange,
}: {
  isSelected?: boolean;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
}) => {
  const checkboxField = useControlledField({
    onChange: (value) => onChange?.(value),
    type: 'checkbox',
    value: isSelected,
  });

  return (
    <CheckboxField
      name='avatar-checkbox'
      disabled={disabled}
      {...checkboxField}
      label=''
      css={{ margin: theme.spacing(0, 0.75) }}
    />
  );
};
